import { t } from "@/i18n-js/instance";
import { TRIGGER_RESOURCE_TYPE } from "@circle-react/components/SettingsApp/Workflows/constants";
import { EntitySelector } from "../../EntitySelector";

const i18nRoot = "settings.workflows.form.entity_type.paywall";

export const entityTypeOptions = [
  {
    value: TRIGGER_RESOURCE_TYPE.PAYWALL_COUPON,
    label: t([i18nRoot, "paywall_coupon.title"]),
    description: t([i18nRoot, "paywall_coupon.description"]),
  },
];

export const AnyPaywallSelector = () => (
  <EntitySelector entityTypeOptions={entityTypeOptions} />
);
